import { TextLanguage } from '@/hooks/use-locale'

import { getFooterLinks, getMainNavConfigs } from '@/configs/router'

import {
  type FooterConfig,
  type HeaderConfig,
  FOOTER_LAYOUT_PRESETS,
  FOOTER_SPACING_OPTIONS,
  FOOTER_WIDTH_OPTIONS,
  HEADER_LAYOUT_PRESETS,
  HEADER_SPACING_OPTIONS,
  HEADER_WIDTH_OPTIONS,
} from '@/types/header-footer-config'

const isNonEmptyArray = <T>(value: T[] | undefined | null): value is T[] => Array.isArray(value) && value.length > 0

export function resolveHeaderConfig(
  config: HeaderConfig = {},
  text: TextLanguage,
  lang: string
): Required<HeaderConfig> {
  return {
    layoutPreset: HEADER_LAYOUT_PRESETS.includes(config?.layoutPreset ?? 'logo-left')
      ? config?.layoutPreset ?? 'logo-left'
      : 'logo-left',
    sticky: config?.sticky ?? true,
    showBorder: config?.showBorder ?? true,
    showLeftSection: config?.showLeftSection ?? true,
    showRightSection: config?.showRightSection ?? true,
    containerWidth: HEADER_WIDTH_OPTIONS.includes(config?.containerWidth ?? 'full')
      ? config?.containerWidth ?? 'full'
      : 'full',
    leftSectionWidth: HEADER_WIDTH_OPTIONS.includes(config?.leftSectionWidth ?? 'auto')
      ? config?.leftSectionWidth ?? 'auto'
      : 'auto',
    rightSectionWidth: HEADER_WIDTH_OPTIONS.includes(config?.rightSectionWidth ?? 'auto')
      ? config?.rightSectionWidth ?? 'auto'
      : 'auto',
    spacing: HEADER_SPACING_OPTIONS.includes(config?.spacing ?? 'normal') ? config?.spacing ?? 'normal' : 'normal',
    navItems: isNonEmptyArray(config?.navItems) ? config.navItems : getMainNavConfigs(text, lang),
    mobileNavItems: isNonEmptyArray(config?.mobileNavItems)
      ? config.mobileNavItems
      : isNonEmptyArray(config?.navItems)
        ? config.navItems
        : getMainNavConfigs(text, lang),
    rightActions: isNonEmptyArray(config?.rightActions) ? config.rightActions : [],
    templatePreset: config?.templatePreset ?? '',
    showForum: config?.showForum ?? true,
    showChat: config?.showChat ?? true,
  }
}

export function resolveFooterConfig(
  config: FooterConfig | undefined,
  text: TextLanguage,
  lang: string
): Required<FooterConfig> {
  return {
    layoutPreset: FOOTER_LAYOUT_PRESETS.includes(config?.layoutPreset ?? 'default')
      ? config?.layoutPreset ?? 'default'
      : 'default',
    showLogo: config?.showLogo ?? false,
    showLinkGroups: config?.showLinkGroups ?? false,
    showSocialLinks: config?.showSocialLinks ?? true,
    showCopyright: config?.showCopyright ?? true,
    showBorder: config?.showBorder ?? true,
    containerWidth: FOOTER_WIDTH_OPTIONS.includes(config?.containerWidth ?? 'content')
      ? config?.containerWidth ?? 'content'
      : 'content',
    spacing: FOOTER_SPACING_OPTIONS.includes(config?.spacing ?? 'normal') ? config?.spacing ?? 'normal' : 'normal',
    linkGroups: config && isNonEmptyArray(config?.linkGroups) ? config.linkGroups : getFooterLinks(text, lang),
  }
}
